import { isDefaultBrand, useConfig } from '@travelwin/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NavItem } from '../interfaces/NavBar';
import { isRemix } from '../utils/ssrUtils';
import { useExternalHomepageConfig } from './useExternalHomepageConfig';

export const useAboutUsItems = () => {
  const { WHITELABEL_BRAND } = useConfig();
  const { t } = useTranslation();
  const { getHomepageUrl, getLocalizedZendeskUrl } =
    useExternalHomepageConfig();

  const aboutUsItem: NavItem = useMemo(
    () => ({
      id: '200',
      label: t('navbar.about_us', 'About Us'),
      visible: isDefaultBrand(WHITELABEL_BRAND),
      items: [
        {
          id: '201',
          label: t('navbar.about_sim_local', 'About Sim Local'),
          to: getHomepageUrl('/about-us/about-sim-local'),
          visible: true,
        },
        {
          id: '202',
          label: t('navbar.careers', 'Careers'),
          to: getHomepageUrl('/about-us/careers'),
          visible: true,
        },
        {
          id: '203',
          label: t('navbar.partners', 'Partners'),
          to: getHomepageUrl('/partners'),
          visible: true,
        },
        {
          id: '204',
          label: t('navbar.affiliates', 'Affiliates'),
          to: getHomepageUrl('/affiliates'),
          visible: true,
        },
        {
          id: '205',
          label: t('navbar.blog', 'Blog'),
          to: isRemix() ? '/news' : getHomepageUrl('/news'),
          visible: true,
          ecommerceRoute: isRemix(),
        },
      ],
    }),
    [t, WHITELABEL_BRAND, getHomepageUrl, getLocalizedZendeskUrl],
  );

  return aboutUsItem;
};
